import React from 'react';
import moment from 'moment';
import { type DeprecatedScaleManager } from 'components/common/ScaleBar';

interface Milestone {
  title: string;
  date: string;
  color: string;
}

interface MilestoneLinesProps {
  milestones: Milestone[];
  scale: DeprecatedScaleManager;
  showMilestoneBars: boolean;
}

const MilestoneLines: React.FC<MilestoneLinesProps> = ({
  milestones,
  scale,
  showMilestoneBars,
}) => {
  const milestonesLines: JSX.Element[] = [];

  milestones.forEach((milestone, index) => {
    return milestonesLines.push(
      <div
        key={`MilestoneLine-${index}`}
        className='roadmap-today-line milestone'
        style={{
          left: scale.dateToRawOffset(moment.utc(milestone.date)),
          top: showMilestoneBars ? '35px' : '0px',
          color: `${milestone.color}`,
          borderLeft: `1px solid ${milestone.color}`,
        }}
      />
    );
  });

  return (
    <div className='timeline-chart__milestone-lines'>{milestonesLines}</div>
  );
};

export default MilestoneLines;
